import { Config } from '../../node_modules/@cvx/cal';

const calConfig: Config = {
  autoSignIn: true,
  popupForLogin: false,
  cacheLocation: 'localStorage',
  instance: 'https://login.microsoftonline.com/',
  tenantId: 'fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
  clientId: '35b1966d-ba0e-4229-9770-1e90d2bbbfe8',
  //redirectUri: 'http://localhost:4200',
  redirectUri: 'https://substa-opgui-dev2.azure.chevron.com',
  oidcScopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  graphScopes: ['User.Read', 'User.Read.All'],
};


export const environment = {
  calConfig: calConfig,
  production: false,
  envName: 'dev',
  scopes: ['https://substa-dev2.azure.chevron.com/user_impersonation'],
  // apiEndpoint: 'http://localhost:8000/',
  apiEndpoint: 'https://substa-opg-api-dev2-cvx.azurewebsites.net/',
  webUrl: 'http://localhost:4200',
  logging: {
    enabled: true,
    level: 'debug'
  }
};
